import React from "react";
import {Chip} from "@mui/material";
import {KeywordEntity} from "../Entity/KeywordEntity.ts";

interface KeywordComponentProps {
	readonly keyword: KeywordEntity;
}

export function KeywordComponent(props: KeywordComponentProps): React.ReactElement {
	return <Chip
		label={props.keyword.hidden ? "" : props.keyword.name}
		sx={{
			minWidth: 100,
			backgroundColor: props.keyword.guessed ? "green" : "",
		}}
	/>;
}
